module.exports = __webpack_public_path__ + "static/img/hx2.fc2a7cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/hx2.png
// module id = 906v
// module chunks = 1